import { borderRadius } from './border-radius'

const variants = {
  contained: {
    primary: {
      color: '#ffffff',
      backgroundColor: '#17ab6a',
      border: `solid 1px #17ab6a`
    }
  }
}

const sizes = {
  small: {
    fontSize: 12,
    width: 192,
    paddingTop: 12,
    paddingBottom: 12
  },
  medium: {
    fontSize: 14,
    width: 206,
    paddingTop: 14,
    paddingBottom: 14
  },
  large: {
    fontSize: 16,
    width: 362,
    paddingTop: 16,
    paddingBottom: 16
  }
}

export const button = {
  primary: (size: string = 'medium') => ({
    textDecoration: 'none',
    display: 'inline-block',
    textAlign: 'center',
    borderRadius: borderRadius.rounded,
    fontWeight: 600,
    ...variants.contained.primary,
    ...sizes[size]
  })
}
